<template>
    <div>
        <v-btn @click="isShow = !isShow" text title="'Load from file">
            <v-icon>mdi-file-upload-outline</v-icon>
        </v-btn>
        <input type="file" name="upload" v-if="isShow" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="*/*"/>
    </div>
</template>

<script>
/**
 * Based upon
 * https://scotch.io/tutorials/how-to-handle-file-uploads-in-vue-2
 * http://simey.me/saving-loading-files-with-javascript/
 *
 * Actually, mozilla documentation is great:
 * Accessing files from web: https://developer.mozilla.org/en-US/docs/Web/API/File/Using_files_from_web_applications
 * FileReader: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/loadend_event
 *
 *
 *
 *
 * <input id="fileField" type="file" />
 * */

export default {

  name: 'FileUpload',

  data() {
    return {
      isShow: false,
      name: null,
      type: null,
      size: null,
      uploadError: null
    };
  },

  computed: {
    isSaving: function () {
      return false;
    }
  },

  methods: {
    filesChange (fieldName, fileList) {
      // handle file changes

      console.log('fieldName', fieldName);
      console.log('fileList', fileList);

      if (!fileList.length) return;

      // actually, I removed the 'multiple, so it always only one
      for (let i = 0; i < fileList.length; i++) {
        const fileObject = fileList[i];

        console.log('file', fileObject);
        this.name = fileObject.name;
        this.type = fileObject.type;
        this.size = fileObject.size;

        // if (!file.type.startsWith('image/')) { continue }

        const reader = new FileReader(); // read the mozilla FileReader documentation
        // define a function on 'load-finished'
        reader.onloadend = (progressEvent) => {
          this.$store.commit('SET_STATE', progressEvent.target.result);
          this.isShow = false;
        }
        // start the reader
        reader.readAsText(fileObject);
      }
    }

  }

};
</script>

<style scoped>

</style>